import { StyleSheet } from 'react-native';
import { JPYCTransferProps } from './type';

export const createStyle = (props: JPYCTransferProps) => {
  return StyleSheet.create({
    container: {
      padding: 20,
      borderRadius: 12,
      backgroundColor: '#ffffff',
      width: '100%',
      height: '100%',
      shadowColor: '#000',
      shadowOpacity: 0.06,
      shadowOffset: { width: 0, height: 4 },
      shadowRadius: 10,
      elevation: 2,
    },
    iconWrapper: {
      alignItems: 'center',
      marginBottom: 16,
    },
    iconCircle: {
      width: 56,
      height: 56,
      borderRadius: 28,
      backgroundColor: '#1e6fff',
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerBlock: {
      alignItems: 'center',
      marginBottom: 12,
    },
    title: {
      fontSize: 20,
      fontWeight: '700',
      color: '#111827',
    },
    subtitle: {
      color: '#6b7280',
      marginTop: 6,
      fontSize: 12,
    },
    amountRow: {
      alignItems: 'flex-end',
      marginTop: 12,
      marginBottom: 20,
      flexDirection: 'row',
      justifyContent: 'center',
    },
    amountValue: {
      fontSize: 48,
      lineHeight: 48,
      fontWeight: '800',
      color: '#111827',
    },
    amountUnit: {
      marginLeft: 8,
      fontSize: 20,
      lineHeight: 30,
      fontWeight: '700',
      color: '#111827',
    },
    section: {
      marginBottom: 12,
    },
    label: {
      fontSize: 12,
      color: '#6b7280',
      marginBottom: 6,
    },
    selectContainer: {
      borderWidth: 1,
      borderColor: '#e5e7eb',
      borderRadius: 8,
      paddingHorizontal: 12,
      paddingVertical: 8,
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
    },
    dot: {
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: '#8247e5',
      marginRight: 8,
    },
    selectAnchor: {
      flex: 1,
      paddingVertical: 6,
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
    },
    selectText: {
      marginLeft: 8,
      fontSize: 14,
      color: '#111827',
    },
    addressBox: {
      borderWidth: 1,
      borderColor: '#e5e7eb',
      borderRadius: 8,
      padding: 12,
      backgroundColor: '#f9fafb',
    },
    addressText: {
      fontSize: 13,
      color: '#374151',
    },
    button: {
      width: '100%',
      height: 44,
      borderRadius: 24,
      backgroundColor: '#1e6fff',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 4,
    },
    buttonText: {
      color: '#ffffff',
      fontWeight: '700',
      fontSize: 16,
    },
    errorText: {
      color: '#ef4444',
      fontSize: 12,
      marginTop: 4,
    },
  });
};
